import type { ReactNode } from 'react';
import { Children, useRef, useState } from 'react';
// TODO add this into shared package
// Should use MenuList from mui directly. i dont't know why but if i use MenuList from shared, ClickAwayListener doesn't work.
import { ClickAwayListener, Grow, MenuList, Paper, Popper } from '@mui/material';
import { Box, Button, MenuItem } from '@packages/shared';

export const MoreMenu = ({ children }: { children: ReactNode }) => {
  const [isMoreMenuOpened, setIsMoreMenuOpened] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);
  /** It will get opposite boolean value from current. */
  const controlMoreMenu = () => setIsMoreMenuOpened((preValue) => !preValue);

  /** It will always close MoreMenu */
  const closeMoreMenuWithForce = () => setIsMoreMenuOpened(false);

  return (
    <Box
      sx={{
        height: 'fit-content',
        position: 'absolute',
        right: '0rem',
        top: '0rem',
      }}
    >
      <Button
        ref={buttonRef}
        onClick={controlMoreMenu}
        sx={{
          bgcolor: 'transparent',
          ':hover': {
            bgcolor: isMoreMenuOpened ? 'grey.main' : 'transparent',
          },
          border: 'none',
          width: '2.5rem',
          height: '2.5rem',
          minHeight: '2.5rem',
          p: '0',
        }}
        size="large"
      >
        <div className="icon-emp-menu-android" />
      </Button>
      <Popper
        open={isMoreMenuOpened}
        anchorEl={buttonRef.current}
        placement="bottom-start"
        disablePortal
        transition
      >
        {({ TransitionProps }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: 'right top',
            }}
          >
            <Paper elevation={4} sx={{ mr: '0.501rem' }}>
              <ClickAwayListener onClickAway={closeMoreMenuWithForce}>
                <MenuList autoFocusItem={isMoreMenuOpened}>
                  {Children.map(children, (child, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <MenuItem key={index} onClick={closeMoreMenuWithForce} sx={{ p: '0' }}>
                      {child}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Box>
  );
};
